var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandArrow = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.429 28.429L.429 5.57h32z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandArrow);
export default ForwardRef;